export default "__VITE_ASSET__8d6db313__"